import React, { useMemo, useState } from 'react'
import { Button, Overlay } from '@enamelai/design-system'
import UiPropertiesPanel, {
  type UiPropertySection,
} from '../components/UiPropertiesPanel'
import UiPreviewCanvas from '../components/UiPreviewCanvas'
import './OverlayShowcase.css'

const OverlayShowcase: React.FC = () => {
  const [open, setOpen] = useState(true)
  const [closeOnClick, setCloseOnClick] = useState(true)
  const [showDialog, setShowDialog] = useState(true)

  const propertySections: UiPropertySection[] = useMemo(
    () => [
      {
        title: 'State',
        fields: [
          {
            id: 'overlay-open',
            label: 'Visible',
            control: (
              <label className="ui-field-checkbox">
                <input
                  id="overlay-open"
                  type="checkbox"
                  checked={open}
                  onChange={(event) => setOpen(event.target.checked)}
                />
                <span>Enabled</span>
              </label>
            ),
          },
          {
            id: 'overlay-close-on-click',
            label: 'Close on backdrop click',
            control: (
              <label className="ui-field-checkbox">
                <input
                  id="overlay-close-on-click"
                  type="checkbox"
                  checked={closeOnClick}
                  onChange={(event) => setCloseOnClick(event.target.checked)}
                />
                <span>Enabled</span>
              </label>
            ),
          },
          {
            id: 'overlay-show-dialog',
            label: 'Sample dialog',
            control: (
              <label className="ui-field-checkbox">
                <input
                  id="overlay-show-dialog"
                  type="checkbox"
                  checked={showDialog}
                  onChange={(event) => setShowDialog(event.target.checked)}
                />
                <span>Enabled</span>
              </label>
            ),
          },
        ],
      },
    ],
    [closeOnClick, open, showDialog],
  )

  return (
    <>
      <UiPreviewCanvas
        title="Overlay"
        description="Semi-transparent backdrop used behind modals, drawers, and dialogs. Light uses 0.4 opacity; mode trial uses 0.6."
        stageClassName="overlay-showcase__stage"
      >
        <section className={`ui-showcase-live`}>
          <h3 className="ui-showcase-live__title">Live preview</h3>
          <p className="ui-showcase-live__note">
            Toggle Dark mode to compare light (0.4) vs (0.6) scrim opacity.
          </p>

          <div className={`overlay-showcase__demo`}>
            <div className="overlay-showcase__page" aria-hidden={open}>
              <div className="overlay-showcase__page-header" />
              <div className="overlay-showcase__page-grid">
                <span />
                <span />
                <span />
                <span />
              </div>
            </div>

            <Overlay
              inline
              open={open}
              onClick={closeOnClick ? () => setOpen(false) : undefined}
            />

            {open && showDialog ? (
              <div
                className={`overlay-showcase__dialog`}
                role="dialog"
                aria-modal
              >
                <h4 className="overlay-showcase__dialog-title">Dialog title</h4>
                <p className="overlay-showcase__dialog-body">
                  Content appears above the overlay backdrop.
                </p>
                <div className="overlay-showcase__dialog-actions">
                  <Button
                    variant="secondary"
                    size="sm"
                    onClick={() => setOpen(false)}
                  >
                    Cancel
                  </Button>
                  <Button
                    variant="primary"
                    size="sm"
                    onClick={() => setOpen(false)}
                  >
                    Confirm
                  </Button>
                </div>
              </div>
            ) : null}
          </div>

          {!open ? (
            <Button variant="primary" size="sm" onClick={() => setOpen(true)}>
              Show overlay
            </Button>
          ) : null}
        </section>
      </UiPreviewCanvas>

      <UiPropertiesPanel componentName="Overlay" sections={propertySections} />
    </>
  )
}

export default OverlayShowcase
